// extracted by mini-css-extract-plugin
export default {"AnimFrame":"styles_AnimFrame__B0Wy-","AnimDuck":"styles_AnimDuck__AlUex","AnimBee":"styles_AnimBee__TgRs0"};